module.exports = "https://cdn.thelire.com/ins/resource/icon_comments2.07bc9564476d6e942832771a29b4c3be.png";